import gql from 'graphql-tag';

export default gql`
  query inventoryReviews($moduleName: String, $selectedRow: InventoryRowInput) {
    inventoryReviews(moduleName: $moduleName, selectedRow: $selectedRow) {
      ReviewWA
      ReviewWS
      ReviewVM
      ReviewOther
    }
  }
`;
